module.exports = __webpack_public_path__ + "img/metamask.c9460842.svg";